import { Dayjs } from "dayjs";

export type Filter = {
  returnId?: string | null;
  returnType: string;
  returnTypeList: ReturnTypeEnum[];
  dealerReference?: string | null;
  invoiceNumber?: string | null;
  nfeNumber?: string | null;
  partNumber?: string | null;
  dealerAccount?: string | null;
  startDate: Dayjs;
  endDate: Dayjs;
};

export type FilterConfig = {
  minDate: Dayjs;
};

export enum ReturnTypeEnum {
  ALL = "ALL",
  ZCRR = "ZCRR",
  ZSPR = "ZSPR",
  NMQ = "ZSPR_NMQ",
}
export type FilterWithInfo = Filter & FilterConfig;
